import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { OmSharePriceCardContainer, OmSharePriceCard } from '@om/component-library-react';
import { getJhbSharePrice, getLdnSharePrice } from '@om/redux/selectors/publicWeb/sharePrice';
import { graphql } from 'gatsby';

function createSlotName(index) {
    return `card-${index + 1}`;
}

function getNumberOfCards(om_share_price_card_slot) {
    return om_share_price_card_slot ? om_share_price_card_slot.length : 0;
}


const SharePriceCardContainer = ({ sharePriceContainerContent }) => {
  
    const { jhbSharePrice, ldnSharePrice } = useSelector(
        createStructuredSelector({
            jhbSharePrice: getJhbSharePrice,
            ldnSharePrice: getLdnSharePrice,
        })
    );

    if (!sharePriceContainerContent) {
        return '';
    }

    const {
        has_boundary,
        section_heading,
        open_tab,
        button_action_type,
        om_share_price_card_slot,
        button_text,
        button_url,
    } = sharePriceContainerContent;

    return (
        <OmSharePriceCardContainer
            buttonText={button_text}
            buttonUrl={button_url.href}
            buttonActionType={button_action_type}
            hasBoundary={has_boundary}
            openTab={open_tab}
            numberOfCards={getNumberOfCards(om_share_price_card_slot)}
            isError
        >
            {section_heading ? (
                <span slot="section-heading" dangerouslySetInnerHTML={{ __html: section_heading }} />
            ) : (
                ''
            )}
            {om_share_price_card_slot
                ? om_share_price_card_slot.map((share_price, index) => {

                      return (
                          <OmSharePriceCard
                              key={createSlotName(index)}
                              slot={createSlotName(index)}
                              flagImageUrl={share_price.flag_image_url.gatsbyImageData.images.fallback.src}
                              stockExchangeName={share_price.stock_exchange_name}
                              amount={share_price.stock_exchange_name == "Johannesburg" ? jhbSharePrice.sharePrice && jhbSharePrice.sharePrice.amount : ldnSharePrice.sharePrice && ldnSharePrice.sharePrice.amount }
                              percentage={share_price.stock_exchange_name == "Johannesburg" ? jhbSharePrice.sharePrice && jhbSharePrice.sharePrice.percentage : ldnSharePrice.sharePrice && ldnSharePrice.sharePrice.percentage }
                              date={share_price.stock_exchange_name == "Johannesburg" ? jhbSharePrice.sharePrice && jhbSharePrice.sharePrice.date : ldnSharePrice.sharePrice && ldnSharePrice.sharePrice.date }
                              isError={jhbSharePrice.sharePrice && jhbSharePrice.sharePrice.amount !== null ? false : true }
                          />
                      );
                  })
                : ''}
        </OmSharePriceCardContainer>
    );
};

export const pageQuery = graphql`
    fragment SharePriceCardContainer on Contentstack_share_price_card_container {
        uid
        button_action_type
        has_boundary
        title
        section_heading
        button_text
        button_url {
            href
            title
        }
        use_heading_as_h1
        om_share_price_card_slot {
            stock_exchange_name
            title
            flag_image_url {
                gatsbyImageData
            }
        }
    }
`;
export default SharePriceCardContainer;
